import { Link } from "react-router-dom";
import { LOGO_URL } from "../lib/brand";
import { AlertTriangle, Star } from "lucide-react";
import { useT } from "../i18n/LanguageContext";
import { track } from "../lib/analytics";

export const Footer = () => {
  const { t } = useT();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-white border-t border-[var(--al-line)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Alphalane" className="h-10 w-10 object-contain" />
            <div className="font-display">
              <div className="font-semibold text-base"><span className="al-grad-text">ALPHALANE</span></div>
              <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">Trading Systems</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-slate-600 leading-relaxed max-w-md">{t.footer.desc}</p>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs uppercase tracking-widest font-semibold text-slate-500">{t.footer.navTitle}</div>
          <ul className="mt-4 space-y-2.5 text-sm text-slate-700">
            <li><a className="hover:text-[var(--al-purple)]" href="/#konzept">{t.nav.konzept}</a></li>
            <li><a className="hover:text-[var(--al-purple)]" href="/#ablauf">{t.nav.ablauf}</a></li>
            <li><a className="hover:text-[var(--al-purple)]" href="/#track-record">{t.nav.track}</a></li>
            <li><a className="hover:text-[var(--al-purple)]" href="/#konditionen">{t.nav.konditionen}</a></li>
            <li><a className="hover:text-[var(--al-purple)]" href="/#faq">{t.nav.faq}</a></li>
            <li><Link className="hover:text-[var(--al-purple)]" to="/blog">Blog</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="text-xs uppercase tracking-widest font-semibold text-slate-500">{t.footer.contactTitle}</div>
          <p className="mt-4 text-sm text-slate-600 leading-relaxed">{t.footer.contactText}</p>
          <a href="/#kontakt" data-testid="footer-contact-cta" onClick={() => track("cta_click", { meta: { id: "footer_contact" } })} className="mt-4 al-cta-ghost inline-flex">
            {t.footer.contactCta}
          </a>

          <div className="mt-6 al-card p-4 al-grad-soft-bg">
            <div className="flex items-start gap-2.5">
              <AlertTriangle className="h-4 w-4 text-amber-600 mt-0.5 flex-shrink-0" />
              <p className="text-[12px] text-slate-700 leading-relaxed">{t.footer.risk}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-[var(--al-line)]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {year} Alphalane Trading Systems. {t.footer.copyright}</div>
          <div className="flex gap-5 flex-wrap items-center">
            <a
              href="https://www.trustpilot.com/review/alphalane-tradingsystems.com"
              target="_blank"
              rel="noopener"
              data-testid="footer-link-trustpilot"
              className="hover:text-slate-900 inline-flex items-center gap-1"
            >
              <Star className="h-3.5 w-3.5" /> Bewertungen auf Trustpilot
            </a>
            <Link data-testid="footer-link-impressum" to="/impressum" className="hover:text-slate-900">{t.footer.links.impressum}</Link>
            <Link data-testid="footer-link-datenschutz" to="/datenschutz" className="hover:text-slate-900">{t.footer.links.datenschutz}</Link>
            <Link data-testid="footer-link-agb" to="/agb" className="hover:text-slate-900">{t.footer.links.agb}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
